angular.module("AccountingBoxApp").component("contactEdit", {
  bindings: {
    customer: "<",
    onSave: "&",
    onDelete: "&"
  },
  templateUrl: "app/contacts/edit/edit.html",
  controller: function($timeout, $rootScope) {
    var vm = this;

    vm.handleDelete = function() {
      $("#customerDeleteModal").appendTo("#app-content");
      $("#customerDeleteModal").modal("show");
    };

    $timeout(function() {
      $('#customerDeleteModal').on('hidden.bs.modal', function () {
        $("#customerDeleteModal").appendTo("#customer-detail");
      });
    })

    vm.handleDeleteConfirm = function() {
      // $("#customerDeleteModal").appendTo("#app-content");
      $("#customerDeleteModal").modal("hide");
      // $("#vendorDeleteModal").modal("hide");
      vm.onDelete({ customer: vm.customer });
    };
  }
});
